import { Router } from "@reach/router";
import { ContentContainer } from "../components/Layout";
import { ContextMenu } from "../components/ContextMenu";
import RfqOverview from "pages/GuestFlow/RfqOverviews/RfqOverview";
import { Breadcrumbs } from "components/Breadcrumb";
import { NotFound } from "./NotFound";
import SharedCompany from "pages/GuestFlow/SharedCompany/SharedCompany";
import { Box } from "@chakra-ui/react";
import ViewRFQPage from "pages/RFQ/RFQ/ViewRFQ/ViewRFQPage";
import { RfxDataProvider } from "newui/features/Rfx/data-provider/RfxDataProvider";
import { RfxSubmissionDataProvider } from "newui/features/Rfx/data-provider/RfxSubmissionDataProvider";
import RFQPreview from "newui/features/Rfx/Submission/RFQPreview";
import GuestRfxSubmissionRedirect from "app/GuestRfxSubmissionRedirect";

export const GuestComponent = ({ path: _path }) => {
	return (
		<Box
			display="flex"
			flexWrap="nowrap"
			width="100%"
			minH="100vh"
		>
			<ContextMenu
				name="sdfsf"
				logo="sdf"
			/>
			<ContentContainer id="element-scroll">
				<Breadcrumbs ignoreCompany={true} />
				<Router primary={false}>
					{/* Guest Submission */}
					<GuestRfxSubmissionRedirect path="request-for-quote/:rfxId/:currentTab" />
					<RfxSubmissionDataProvider
						path="rfx/:rfxRouteId/submission"
					>
						<RFQPreview
							path="/"
						/>
						<RFQPreview
							path=":currentTab"
						/>
						<RFQPreview
							path=":currentTab/:contextId"
							isGuest
						/>
					</RfxSubmissionDataProvider>

					{/* RFx Approval Process */}
					<RfxDataProvider path="rfx/:rfxRouteId/view-approval">
						<RfxSubmissionDataProvider
							path="/"
						>
							<ViewRFQPage path="/" />
						</RfxSubmissionDataProvider>
					</RfxDataProvider>

					{/* RFx Grid view for Guests */}
					<RfqOverview path="/rfx" />
					{/*  */}

					{/* <RfxSubmissionDataProvider isGuest={true} path="rfx/:rfxRouteId" useParentRfxData={false}> */}

					{/* <RFQPreview
							path=":currentTab"
							isGuest
						/> */}
					{/* </RfxSubmissionDataProvider> */}

					<SharedCompany path="/shared-companies" />
					<NotFound default />
				</Router>
			</ContentContainer>
		</Box>
	);
};

export const Guest = GuestComponent;
